import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './PolicyRichTextEditor.css';

export type PolicyRichTextEditorProps = {
  value: string;
  onChange: (html: string) => void;
  disabled?: boolean;
  id?: string;
};

const TOOLBAR_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, 4, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean'],
  ],
};

const PolicyRichTextEditor: React.FC<PolicyRichTextEditorProps> = ({
  value,
  onChange,
  disabled = false,
  id,
}) => {
  const modules = useMemo(() => TOOLBAR_MODULES, []);

  return (
    <div className="policy-rich-text-editor" id={id}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        readOnly={disabled}
      />
    </div>
  );
};

export default PolicyRichTextEditor;
